import { Typography } from '@mui/material'
import { TableProductsList } from '../../components/TableProductsList/TableProductsList'
import * as S from './RestockingGenerateLists.styles'

interface RestockingGenerateListsProps {
  forTransfer?: boolean
}

const RestockingGenerateLists = ({
  forTransfer = false,
}: RestockingGenerateListsProps) => (
  <S.Wrapper>
    <Typography variant='h5' fontWeight='bold'>Gerar Listas</Typography>
    <TableProductsList forTransfer={forTransfer} />
  </S.Wrapper>
)

export default RestockingGenerateLists
